var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 3C7.75 2.7298 7.60466 2.48048 7.36952 2.34735C7.13439 2.21422 6.84583 2.21786 6.61413 2.35688L1.61413 5.35688C1.38822 5.49242 1.25 5.73655 1.25 6C1.25 6.26345 1.38822 6.50758 1.61413 6.64312L6.61413 9.64312C6.84583 9.78214 7.13439 9.78578 7.36952 9.65265C7.60466 9.51952 7.75 9.2702 7.75 9V6.75H19C20.2426 6.75 21.25 7.75736 21.25 9V15C21.25 16.2426 20.2426 17.25 19 17.25H7C6.58579 17.25 6.25 17.5858 6.25 18C6.25 18.4142 6.58579 18.75 7 18.75H19C21.0711 18.75 22.75 17.0711 22.75 15V9C22.75 6.92893 21.0711 5.25 19 5.25H7.75V3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoAlt);
export default __webpack_public_path__ + "static/media/undo-alt.78c33dd256f707c9063ba197b2b326df.svg";
export { ForwardRef as ReactComponent };